<template>
  <b-modal id="my-modal" ref="modal" centered hide-footer hide-header>
    <div class="content">
      <table>
        <tr>
          <td>{{ $t('PAPER') }}</td>
          <td>
            <div class="file-name">{{ fileName }}</div>
            <div class="button-holder">
              <primary-button
                blue
                pure-icon
                :text="$t('SELECT_FILE')"
                @click="$refs.file.click()"
              >
                <template slot="icon">
                  <font-awesome-icon :icon="faFolderOpen" />
                </template>
              </primary-button>
            </div>
          </td>
        </tr>
        <tr>
          <td>{{ $t('PAPER_TYPE') }}</td>
          <td>
            <select-input :items="clientDocTypes" v-model="docType" />
          </td>
        </tr>
      </table>
      <div class="btns float-right">
        <primary-button class="action-button" @click="off" independence :text="$t('BACK')" />
        <primary-button class="action-button" @click="upload" :disabled="disabled" blue :text="$t('CONFIRM')" />
      </div>

      <input class="input-file" type="file" ref="file" @change="selectFile">
    </div>
  </b-modal>
</template>

<script>
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import PrimaryButton from '@/components/PrimaryButton';
import SelectInput from '@/components/SelectInput';

import { watch, ref, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import ClientDetailServices from '../../../ClientDetailServices';

const { useState, useActions } = createNamespacedHelpers('clientDetail');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');
const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  name: 'DocumentUpload',
  components: {
    PrimaryButton,
    FontAwesomeIcon,
    SelectInput
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
  },
  setup(props, { root, emit }) {
    const { clientDocTypes: clientDocTypes_ } = useAppState(['clientDocTypes']);
    const { getClientDocs } = useActions(['getClientDocs']);
    const { info: flashInfo, error: flashError } = useFlashActions(['info', 'error']);

    const { targetingClient } = useState(['targetingClient']);

    const clientDocTypes = computed(() => clientDocTypes_.value.map((t) => ({
      text: root.$t(t.key),
      value: t.id
    })));

    const docType = ref(4);

    const file = ref(null);
    const modal = ref(null);

    const selectFile = (event) => {
      [file.value] = event.target.files;

      if (file.size > 10 * 1024 * 1024) {
        flashError(root.$t('FILE_TOO_LARGE'));
        file.value = null;
      }
    };

    const fileName = computed(() => {
      if (file.value === null) {
        return '';
      }
      return file.value.name;
    });

    const disabled = computed(() => !file.value);

    const popup = computed(() => props.value);

    watch(popup, (value) => {
      if (value) {
        modal.value.show();
      } else {
        modal.value.hide();
      }
    });

    const off = () => {
      emit('input', false);
      file.value = null;
    };

    const upload = async () => {
      const formData = new FormData();

      formData.append('type', root.$t(docType.value));
      formData.append('path', file.value);

      await ClientDetailServices.uploadDocument(targetingClient.value.id, formData);

      getClientDocs();

      flashInfo(root.$t('SUCCESSFULLY_UPLOADED_DOCUMENT'));
      off();
    };

    return {
      modal,
      faFolderOpen,
      clientDocTypes,
      selectFile,
      fileName,
      disabled,
      off,
      upload,
      docType
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#my-modal {
  .content {
    .file-name {
      border-radius: 4px;
      border: 1px solid $independence;
      width: calc(100% - 50px);
      height: 40px;
      display: inline-block;
      padding: 7px 15px;
      box-sizing: border-box;
    }

    table {
      width: 100%;
      margin: 20px 0px;

      tr {
        td {
          padding: 5px;
          white-space: nowrap;

          .button-holder {
            vertical-align: top;
            margin-left: 10px;
            display: inline-block;

            .primary-button {
              border-radius: 4px;
            }
          }

          .select-input {
            width: 100%;

            /deep/ .display {
              border-radius: 4px;
            }
          }

          &:last-child {
            width: 350px;
          }
        }
      }
    }

    .input-file {
      display: none
    }

    .action-button {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
</style>
